<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <h1 class="text-center">Localrent Administration</h1>
        <h2 class="subtitle text-center" v-if="!authenticated">You need to login</h2>
        <div class="text-center" v-if="!authenticated">
          <v-btn rounded color="primary" :to="{ name: 'SignIn' }">Login</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',
  computed: {
    ...mapState('auth', ['authenticated']),
  },
};
</script>
